module.exports = __webpack_public_path__ + "img/bps_logo.7ea3c869.svg";